/**
 * @license
 *
 * Copyright IBM Corp. 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { css } from 'lit';
export default css([
  ':host(clabs-chat-error) .clabs--chat-error-container{display:flex;padding:10px;border:1px solid var(--cds-support-error,#da1e28);border-radius:8px;background-color:var(--cds-background,#fff);color:var(--cds-support-error,#da1e28);line-height:22px;max-block-size:176px;overflow-y:auto}',
]);
